/**
 * Created by fworld on 2019/10/8.
 */
import request from '@/util/request'

export const makeVideoCreate = (data) => {
    return request({
        'url': '/api/v1/delivery/makeVideo/create',
        'method': 'post',
        data
    })
}

export const makeVideoUpdate = (data) => {
    return request({
        'url': '/api/v1/delivery/makeVideo/update',
        'method': 'post',
        data
    })
}

export const makeVideoList = () => {
    return request({
        'url': '/api/v1/delivery/makeVideo/list',
        'method': 'get',
    })
}

export const makeVideoDeviceUnion = (params) => {
    return request({
        'url': '/api/v1/delivery/makeVideo/device/union',
        'method': 'get',
        params
    })
}

export const makeVideoDeviceList = (params) => {
    return request({
        'url': '/api/v1/delivery/makeVideo/device/list',
        'method': 'get',
        params
    })
}

export const makeVideoDeviceBind = (data) => {
    return request({
        'url': '/api/v1/delivery/makeVideo/device/bind',
        'method': 'post',
        data
    })
}

export const makeVideoDeviceUnBind = (params) => {
    return request({
        'url': '/api/v1/delivery/makeVideo/device/unbind',
        'method': 'get',
        params
    })
}
